//import { Path } from '../routes'
import * as types from '../constants/Action_types'

const initialState = {
    email: null
}

export default function (state = initialState, action) {

    switch (action.type) {

        case types.GET_EMAILS:
            return {
                ...state,
                email: action.payload
            }
        default:
            return state
    }
}

